export enum ConfigurationTab {
    Categories = 'categories',
    Units = 'units',
    Attributes = 'attributes',
    Tags = 'tags',
}
